import { createGlobalStyle } from 'styled-components/macro';
import { colorShade } from '@twnel/web-components';

const DatepickerStyle = createGlobalStyle`
  .react-datepicker {
    font-family: Quicksand, sans-serif;

    .react-datepicker__day.react-datepicker__day--selected,
    .react-datepicker__day.react-datepicker__day--in-selecting-range,
    .react-datepicker__day.react-datepicker__day--in-range,
    .react-datepicker__day.react-datepicker__month-text--selected,
    .react-datepicker__day.react-datepicker__month-text--in-selecting-range,
    .react-datepicker__day.react-datepicker__month-text--in-range,
    .react-datepicker__day.react-datepicker__quarter-text--selected,
    .react-datepicker__day.react-datepicker__quarter-text--in-selecting-range,
    .react-datepicker__day.react-datepicker__quarter-text--in-range {
      background-color: ${({ theme }) => theme.brand};
      color: #FFFFFF;

      &:hover {
        background-color: ${({ theme }) => colorShade(2, theme.brand)};
      }
    }
  }
`;

export default DatepickerStyle;
